/**
 * AI Launch Advisor API
 */
import { request } from './core.js';

export async function getAiHealth() {
  return request('/api/ai/health');
}

export async function postAiRecommend(body) {
  return request('/api/ai/recommend', {
    method: 'POST',
    body: JSON.stringify(body),
  });
}
